// Inline SVG icon set — stroke-based, scales via `size` prop (default 16)
function Ico({ size = 16, fill = 'none', style, children, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0, ...style }}
      {...rest}
    >
      {children}
    </svg>
  );
}

export const IcoCash = ({ size = 16 }) => (
  <Ico size={size}>
    <rect x="2" y="6" width="20" height="12" rx="2"/>
    <circle cx="12" cy="12" r="2.5"/>
    <path d="M6 12h.01M18 12h.01"/>
  </Ico>
);

export const IcoCard = ({ size = 16 }) => (
  <Ico size={size}>
    <rect x="2" y="5" width="20" height="14" rx="2"/>
    <line x1="2" y1="10" x2="22" y2="10"/>
    <line x1="6" y1="15" x2="10" y2="15"/>
  </Ico>
);

export const IcoTransfer = ({ size = 16 }) => (
  <Ico size={size}>
    <polyline points="17 1 21 5 17 9"/>
    <path d="M3 11V9a4 4 0 0 1 4-4h14"/>
    <polyline points="7 23 3 19 7 15"/>
    <path d="M21 13v2a4 4 0 0 1-4 4H3"/>
  </Ico>
);

export const IcoMixed = ({ size = 16 }) => (
  <Ico size={size}>
    <polyline points="16 3 21 3 21 8"/>
    <line x1="4" y1="20" x2="21" y2="3"/>
    <polyline points="21 16 21 21 16 21"/>
    <line x1="15" y1="15" x2="21" y2="21"/>
  </Ico>
);

export const IcoUser = ({ size = 16 }) => (
  <Ico size={size}>
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </Ico>
);

export const IcoWarning = ({ size = 16 }) => (
  <Ico size={size}>
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
    <line x1="12" y1="9" x2="12" y2="13"/>
    <line x1="12" y1="17" x2="12.01" y2="17"/>
  </Ico>
);

export const IcoCheck = ({ size = 16 }) => (
  <Ico size={size}>
    <polyline points="20 6 9 17 4 12"/>
  </Ico>
);

export const IcoClose = ({ size = 14 }) => (
  <Ico size={size}>
    <line x1="18" y1="6" x2="6" y2="18"/>
    <line x1="6" y1="6" x2="18" y2="18"/>
  </Ico>
);

export const IcoEdit = ({ size = 16 }) => (
  <Ico size={size}>
    <path d="M12 20h9"/>
    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>
  </Ico>
);

export const IcoArrowUp = ({ size = 14 }) => (
  <Ico size={size}>
    <line x1="12" y1="19" x2="12" y2="5"/>
    <polyline points="5 12 12 5 19 12"/>
  </Ico>
);

export const IcoArrowDown = ({ size = 14 }) => (
  <Ico size={size}>
    <line x1="12" y1="5" x2="12" y2="19"/>
    <polyline points="19 12 12 19 5 12"/>
  </Ico>
);

export const IcoReturn = ({ size = 16 }) => (
  <Ico size={size}>
    <polyline points="9 14 4 9 9 4"/>
    <path d="M20 20v-7a4 4 0 0 0-4-4H4"/>
  </Ico>
);

export const IcoEmail = ({ size = 16 }) => (
  <Ico size={size}>
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22 6 12 13 2 6"/>
  </Ico>
);

export const IcoPrint = ({ size = 16 }) => (
  <Ico size={size}>
    <polyline points="6 9 6 2 18 2 18 9"/>
    <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/>
    <rect x="6" y="14" width="12" height="8"/>
  </Ico>
);

export const IcoTabs = ({ size = 16 }) => (
  <Ico size={size}>
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <line x1="3" y1="9" x2="21" y2="9"/>
    <line x1="9" y1="9" x2="9" y2="21"/>
  </Ico>
);

export const IcoTrash = ({ size = 16 }) => (
  <Ico size={size}>
    <polyline points="3 6 5 6 21 6"/>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
  </Ico>
);

export const IcoReceipt = ({ size = 16 }) => (
  <Ico size={size}>
    <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1z"/>
    <line x1="8" y1="9" x2="16" y2="9"/>
    <line x1="8" y1="13" x2="14" y2="13"/>
  </Ico>
);

export const IcoClipboard = ({ size = 16 }) => (
  <Ico size={size}>
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
    <rect x="8" y="2" width="8" height="4" rx="1"/>
  </Ico>
);

export const IcoNote = ({ size = 16 }) => (
  <Ico size={size}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="16" y1="13" x2="8" y2="13"/>
    <line x1="16" y1="17" x2="8" y2="17"/>
  </Ico>
);

export const IcoBluetooth = ({ size = 16 }) => (
  <Ico size={size}>
    <polyline points="6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5"/>
  </Ico>
);

export const IcoDownload = ({ size = 16 }) => (
  <Ico size={size}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
    <polyline points="7 10 12 15 17 10"/>
    <line x1="12" y1="15" x2="12" y2="3"/>
  </Ico>
);

export const IcoStar = ({ size = 16, filled = false }) => (
  <Ico size={size} fill={filled ? 'currentColor' : 'none'}>
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
  </Ico>
);

export const IcoPackage = ({ size = 32 }) => (
  <Ico size={size}>
    <line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/>
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
    <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
    <line x1="12" y1="22.08" x2="12" y2="12"/>
  </Ico>
);

export const IcoNumpad = ({ size = 18 }) => (
  <Ico size={size}>
    <rect x="3" y="3" width="4" height="4" rx="0.5" fill="currentColor" stroke="none"/>
    <rect x="10" y="3" width="4" height="4" rx="0.5" fill="currentColor" stroke="none"/>
    <rect x="17" y="3" width="4" height="4" rx="0.5" fill="currentColor" stroke="none"/>
    <rect x="3" y="10" width="4" height="4" rx="0.5" fill="currentColor" stroke="none"/>
    <rect x="10" y="10" width="4" height="4" rx="0.5" fill="currentColor" stroke="none"/>
    <rect x="17" y="10" width="4" height="4" rx="0.5" fill="currentColor" stroke="none"/>
    <rect x="3" y="17" width="4" height="4" rx="0.5" fill="currentColor" stroke="none"/>
    <rect x="10" y="17" width="4" height="4" rx="0.5" fill="currentColor" stroke="none"/>
    <rect x="17" y="17" width="4" height="4" rx="0.5" fill="currentColor" stroke="none"/>
  </Ico>
);

export const IcoStore = ({ size = 24 }) => (
  <Ico size={size}>
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9 22 9 12 15 12 15 22"/>
  </Ico>
);

export const IcoTables = ({ size = 16 }) => (
  <Ico size={size}>
    <rect x="3" y="3" width="7" height="7" rx="1.5"/>
    <rect x="14" y="3" width="7" height="7" rx="1.5"/>
    <rect x="3" y="14" width="7" height="7" rx="1.5"/>
    <circle cx="17.5" cy="17.5" r="3.5"/>
  </Ico>
);

export const IcoSearch = ({ size = 16 }) => (
  <Ico size={size}>
    <circle cx="11" cy="11" r="8"/>
    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
  </Ico>
);

// Una tablet: "Este aparato"
export const IcoAparato = ({ size = 16 }) => (
  <Ico size={size}>
    <rect x="4" y="2" width="16" height="20" rx="2"/>
    <line x1="11" y1="18" x2="13" y2="18"/>
  </Ico>
);
